import type {FC, PropsWithChildren} from 'react';
import clsx from 'clsx';

import {Container} from '@/modules/foundation/components/container';
import {Heading} from '@/modules/foundation/components/typography/heading';
import type {PortableTextOverrides} from '@/modules/foundation/sanity/portable-text';

type Props = PropsWithChildren & {
	heading?: string;
	textAlignment?: 'left' | 'center';
};

export const textHeadingPortableTextOverrides: PortableTextOverrides = {
	p: 'text-balance',
};

export const TextHeading: FC<Props> = ({heading, children, textAlignment = 'left'}) => {
	return (
		<>
			<Container spacingBottom="large" spacingTop="large">
				<div
					className={clsx(
						'max-w-3xl',
						textAlignment === 'center' && ['text-center', 'mx-auto'],
					)}
				>
					<Heading spacing>{heading}</Heading>
					{children}
				</div>
			</Container>

			<div
				className={clsx(
					'overflow-hidden',
					'absolute',
					'top-0',
					'left-0',
					'right-0',
					'bottom-0',
					'-z-50',
					'before:transition-all',
					'before:rounded-[34%_66%_50%_50%_/_30%_20%_80%_70%]',
					'md:before:rounded-[34%_66%_50%_50%_/_30%_69%_31%_70%]',
					'before:absolute',
					'before:top-32',
					'before:left-1/2',
					'before:-translate-x-1/2',
					'before:h-screen',
					'before:w-[150vw]',
					'before:bg-gradient-to-b',
					'before:from-[#E0F6FF]',
					'before:to-white',
				)}
			/>
		</>
	);
};
